import { useSyncExternalStore } from 'react'

const STORAGE_KEY = 'p360-plan-sections-dock'
const CHANGE_EVENT = 'p360:plan-sections-dock-change'

/** On unless the user switched it off: the sections bar pinned under the cockpit, each section in a
 *  dialog. Off, the sections stand under the cockpit as before. */
const readIsDockEnabled = () => {
  try {
    return localStorage.getItem(STORAGE_KEY) !== 'off'
  } catch {
    return true
  }
}

export const setPlanSectionsDockEnabled = (isEnabled: boolean) => {
  try {
    if (isEnabled) {
      localStorage.removeItem(STORAGE_KEY)
    } else {
      localStorage.setItem(STORAGE_KEY, 'off')
    }
  } catch {
    // The choice then holds for this page only.
  }

  window.dispatchEvent(new Event(CHANGE_EVENT))
}

const subscribe = (onChange: () => void) => {
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) {
      onChange()
    }
  }

  window.addEventListener(CHANGE_EVENT, onChange)
  window.addEventListener('storage', onStorage)

  return () => {
    window.removeEventListener(CHANGE_EVENT, onChange)
    window.removeEventListener('storage', onStorage)
  }
}

export const usePlanSectionsDockEnabled = () =>
  useSyncExternalStore(subscribe, readIsDockEnabled, () => true)
